module.exports = "/fast-coin/img/two.svg";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/two.svg
// module id = 2385
// module chunks = 5